export const colors = {
    PRIMARY_PURPLE: '#6a37e3',
}